module.exports = __webpack_public_path__ + "img/approve_template.1abc84a5.svg";